import type { IPipelineInformation } from '../../../../../Model/index.js'
import { TooltipTrigger } from '../../../../../Provider/TooltipManager.js'
import { ArrowPathIcon, CheckCircleIcon, ExclamationTriangleIcon, XCircleIcon } from '@heroicons/react/16/solid'
import type React from 'react'

export const deriveItemState = (item: IPipelineInformation | undefined | null) => {
  if (!item) {
    return (
      <TooltipTrigger tooltip={'In progress'}>
        <ArrowPathIcon className="w-4 h-4" />
        </TooltipTrigger>
    )
  } else if (item.errorAt) {
    return (
      <TooltipTrigger tooltip="Processing encountered an error">
        <XCircleIcon className="w-4 h-4" />
        </TooltipTrigger>
    )
  } else if (item.completedAt && item.qualityVerifiedAt) {
    return (
      <TooltipTrigger tooltip={'Item has been processed'}>
        <CheckCircleIcon className="w-4 h-4" />
        </TooltipTrigger>
    )
  } else if (item.completedAt && !item.qualityVerifiedAt) {
    return (
      <TooltipTrigger tooltip={'Item quality is insufficient'}>
        <ExclamationTriangleIcon className="w-4 h-4" />
        </TooltipTrigger>
    )
  } else {
    return (
      <TooltipTrigger tooltip={'In progress'}>
        <ArrowPathIcon className="w-4 h-4" />
        </TooltipTrigger>
    )
  }
}